export type GroupByField = { name: string; title: string }

export function addField(value: readonly string[], name: string): string[] {
  if (!name || value.includes(name)) return [...value]
  return [...value, name]
}

export function removeField(value: readonly string[], name: string): string[] {
  return value.filter((n) => n !== name)
}

export function moveUp(value: readonly string[], name: string): string[] {
  const i = value.indexOf(name)
  if (i <= 0) return [...value]
  const next = [...value]
  const prev = next[i - 1]
  next[i - 1] = next[i]
  next[i] = prev
  return next
}

export function moveDown(value: readonly string[], name: string): string[] {
  const i = value.indexOf(name)
  if (i < 0 || i >= value.length - 1) return [...value]
  const next = [...value]
  const cur = next[i]
  next[i] = next[i + 1]
  next[i + 1] = cur
  return next
}

export function dropStale(value: readonly string[], fieldNames: readonly string[]): string[] {
  const ok = new Set(fieldNames)
  return value.filter((n) => ok.has(n))
}

export function chipLabel(value: readonly string[], fields: readonly GroupByField[]): string {
  if (value.length === 0) return 'Group by'
  return value.map((n) => fields.find((f) => f.name === n)?.title || n).join(' › ')
}

export function availableFields(
  fields: readonly GroupByField[],
  draft: readonly string[],
): GroupByField[] {
  const used = new Set(draft)
  return fields.filter((f) => !used.has(f.name))
}
